import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ItemService = {
  itemList: async ({
    namesearch,
    PriceMin,
    PriceMax,
    categoryId,
    page = 1,
    pageSize = 1000,
    fetchHidden,
    ShowInOrder = true,
  } = {}) => {
    const filterList = [];
    if (namesearch && namesearch.trim())
      filterList.push(`Name=${encodeURIComponent(namesearch.trim())}`);
    if (PriceMin && !isNaN(PriceMin))
      filterList.push(`PriceMin=${parseFloat(PriceMin)}`);
    if (PriceMax && !isNaN(PriceMax))
      filterList.push(`PriceMax=${parseFloat(PriceMax)}`);
    if (categoryId && !isNaN(categoryId))
      filterList.push(`categoryId=${parseInt(categoryId)}`);
    if (page) filterList.push(`Page=${page}`);
    if (pageSize) filterList.push(`PageSize=${pageSize}`);
    if (ShowInOrder) filterList.push(`ShowInOrder=${ShowInOrder}`);
    if (fetchHidden) filterList.push(`fetchHidden=${fetchHidden}`);
    const filterString =
      filterList.length > 0 ? `?${filterList.join("&")}` : "";
    const response = await apiService.get(`/products${filterString}`);
    return response.data;
  },

  itemTheme: async (orgcode) => {
    const response = await apiService.get("/detailsbyapicode/orgcode", {
      headers: {
        APIKEY: orgcode, // pass orgcode in header instead of query param
      },
    });
    return response.data;
  },
  tagsList: async () => {
    const response = await apiService.get("/tags");
    return response.data;
  },
  List: async (id) => {
    const response = await apiService.get(
      `/orderdetailv1/customeritem?customerId=${id}&isCustomer=true`
    );
    return response.data;
  },
  create: async (data) => {
    try {
      const response = await apiService.post("/products", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await apiService.put(`/products/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating:", error);
      throw error;
    }
  },

  productDetail: async (id) => {
    const response = await apiService.get(`/products/${id}`);
    return response.data;
  },

  list: async () => {
    const response = await apiService.get(
      `/items/ispackage?isPackage=${false}`
    );
    return response.data;
  },

  getDetail: async (id) => {
    const response = await apiService.get(`/products/${id}`);
    return response.data;
  },

  viewItem: async (id) => {
    const response = await apiService.get(`/products/${id}`);
    return response.data;
  },
  deleteItem: async (id) => {
    const response = await apiService.delete(`/products/${id}`);
    return response.data;
  },
  // update: async (id, updatedData) => {
  //   try {
  //     const response = await apiService.put(`/items/${id}`, updatedData);
  //     return response.data;
  //   } catch (error) {
  //     console.error("Error updating ratecard:", error);
  //     throw error;
  //   }
  // },
  createWithPackage: async (data) => {
    try {
      const response = await apiService.post("/products/withpackage", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  createWithSides: async (data) => {
    try {
      const response = await apiService.post("/products/sidespackage", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating:", error);
      throw error;
    }
  },
  updateWithSides: async (id, data) => {
    try {
      const response = await apiService.put(
        `/products/sidespackage/${id}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating:", error);
      throw error;
    }
  },
  getProductAttributeById: async (id) => {
    const response = await apiService.get(
      `/products/attributebyproductid/${id}`
    );
    return response.data;
  },

  getPriceChangeLogs: async ({ productId, pageNumber = 1, pageSize = 10 } = {}) => {
    const queryParams = new URLSearchParams();
    if (productId) queryParams.append("productId", productId);
    queryParams.append("pageNumber", pageNumber);
    queryParams.append("pageSize", pageSize);

    const response = await apiService.get(`/products/price-change-logs?${queryParams.toString()}`);
    return response.data;
  },
};

export default ItemService;
